export const BOOKED_APPOINTMENT_CLEAR = 'BOOKED_APPOINTMENT_CLEAR';



// WEBPACK FOOTER //
// ./app/constants/bookedAppointmentTypes.js